"use client";

import { c as _c } from "react/compiler-runtime";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonDropdownItemsDefaultWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsDefaultWrapper";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { useMemo, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsRestoreLinkPreviews from "./WaveDropActionsRestoreLinkPreviews";
import WaveDropActionsSetPinnedDrop from "./WaveDropActionsSetPinnedDrop";
interface WaveDropActionsMoreProps {
  readonly drop: ExtendedDrop;
  readonly onOpenChange?: (isOpen: boolean) => void;
}
export default function WaveDropActionsMore(t0) {
  const $ = _c(60);
  const {
    drop,
    onOpenChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const buttonRef = useRef(null);
  const {
    canDelete,
    canSetPinnedDrop
  } = useDropInteractionRules(drop);
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = newIsOpen => {
      setIsOpen(newIsOpen);
      onOpenChange?.(newIsOpen);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== handleOpenChange) {
    t2 = () => handleOpenChange(false);
    $[2] = handleOpenChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeDropdown = t2;
  let t3;
  if ($[4] !== handleOpenChange) {
    t3 = () => {
      handleOpenChange(false);
      setIsDeleteModalOpen(true);
    };
    $[4] = handleOpenChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDeleteClick = t3;
  let t4;
  if ($[6] !== drop.parts) {
    bb0: {
      const media = drop.parts.at(0)?.media.at(0);
      const url = media?.url;
      if (!url) {
        t4 = null;
        break bb0;
      }
      t4 = getFileInfoFromUrl(url);
    }
    $[6] = drop.parts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const mediaInfo = t4;
  let t5;
  if ($[8] !== handleOpenChange || $[9] !== isOpen) {
    t5 = () => handleOpenChange(!isOpen);
    $[8] = handleOpenChange;
    $[9] = isOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `more-actions-${drop.id}`;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <EllipsisHorizontalIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isOpen || $[13] !== t5 || $[14] !== t6) {
    t8 = <button ref={buttonRef} className="tw-flex tw-h-7 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200" onClick={t5} aria-label="More actions" aria-haspopup="true" aria-expanded={isOpen} data-tooltip-id={t6}>{t7}</button>;
    $[12] = isOpen;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop.id || $[17] !== isOpen) {
    t9 = !isOpen && <Tooltip id={`more-actions-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">More</span></Tooltip>;
    $[16] = drop.id;
    $[17] = isOpen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[19] !== closeDropdown || $[20] !== drop) {
    t10 = <WaveDropActionsMarkUnread drop={drop} isDropdownItem={true} onMarkUnread={closeDropdown} />;
    t11 = <WaveDropActionsCopyLink drop={drop} isDropdownItem={true} onCopy={closeDropdown} />;
    t12 = <WaveDropActionsRestoreLinkPreviews drop={drop} onRestored={closeDropdown} />;
    t13 = <WaveDropActionsOpen drop={drop} isDropdownItem={true} onOpen={closeDropdown} />;
    $[19] = closeDropdown;
    $[20] = drop;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
    t13 = $[24];
  }
  let t14;
  if ($[25] !== closeDropdown || $[26] !== drop.id || $[27] !== drop.parts || $[28] !== mediaInfo) {
    t14 = mediaInfo && <WaveDropActionsDownload href={drop.parts.at(0)?.media.at(0)?.url ?? ""} name={mediaInfo.name} extension={mediaInfo.extension} tooltipId={`download-media-${drop.id}`} isDropdownItem={true} onDownload={closeDropdown} />;
    $[25] = closeDropdown;
    $[26] = drop.id;
    $[27] = drop.parts;
    $[28] = mediaInfo;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== canSetPinnedDrop || $[31] !== closeDropdown || $[32] !== drop) {
    t15 = canSetPinnedDrop && <WaveDropActionsSetPinnedDrop drop={drop} onPinnedDropSet={closeDropdown} />;
    $[30] = canSetPinnedDrop;
    $[31] = closeDropdown;
    $[32] = drop;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== canDelete || $[35] !== drop || $[36] !== handleDeleteClick) {
    t16 = canDelete && <WaveDropActionsOptions drop={drop} isDropdownItem={true} onDelete={handleDeleteClick} />;
    $[34] = canDelete;
    $[35] = drop;
    $[36] = handleDeleteClick;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t15 || $[44] !== t16) {
    t17 = <li className="tw-list-none"><div className="tw-flex tw-flex-col tw-gap-y-1 tw-py-1">{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div></li>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== handleOpenChange || $[47] !== isOpen || $[48] !== t17) {
    t18 = <CommonDropdownItemsDefaultWrapper isOpen={isOpen} setOpen={handleOpenChange} buttonRef={buttonRef}>{t17}</CommonDropdownItemsDefaultWrapper>;
    $[46] = handleOpenChange;
    $[47] = isOpen;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== drop || $[51] !== isDeleteModalOpen) {
    t19 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[50] = drop;
    $[51] = isDeleteModalOpen;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t19) {
    t20 = <CommonAnimationWrapper mode="sync" initial={true}>{t19}</CommonAnimationWrapper>;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t18 || $[56] !== t20 || $[57] !== t8 || $[58] !== t9) {
    t21 = <>{t8}{t9}{t18}{t20}</>;
    $[55] = t18;
    $[56] = t20;
    $[57] = t8;
    $[58] = t9;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  return t21;
}
function _temp(e) {
  return e.stopPropagation();
}